module.exports = __webpack_public_path__ + "static/media/logo.a127ff6f.png";